import formatDaterange from "../../../../../gd/format/daterange"
import {momentRange} from "../../../../../gd/convert/moment-range"

export default class ReportProjectTimeReportByUser_Settings {

    public projectId            : ID | null
    public daterange            : DateRange
    public users                : ID[]
    public hideEmptyWorkItems   : boolean
    public estimate             : boolean
    public timeReported         : boolean
    public spentEstimate        : boolean

    constructor(data: any) {
        this.daterange            = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectId            = _.get(data, "projectId", null)
        this.users                = _.get(data, "users", [])
        this.hideEmptyWorkItems   = _.get(data, "hideEmptyWorkItems", true)
        this.estimate             = _.get(data, "estimate", false)
        this.timeReported         = _.get(data, "timeReported", false)
        this.spentEstimate        = _.get(data, "spentEstimate", false)
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId            : this.projectId,
            users                : this.users,
            hideEmptyWorkItems   : this.hideEmptyWorkItems,
            estimate             : this.estimate,
            timeReported         : this.timeReported,
            spentEstimate        : this.spentEstimate,
            daterange            : null      // kept as null on purpose: a missing key would restore the default range
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
